import { SettingConst } from '@faire/web-api--source/types';

/**
 * Experiment setting for splitting New Brands and New Products c1s in navigation
 */
export const NEW_ARRIVALS_HUB_XP_250201 =
  'NEW_ARRIVALS_HUB_XP_250201' as SettingConst<
    'NEW_ARRIVALS_HUB_XP_250201',
    boolean,
    'RETAILER' | 'VISITOR_WEB'
  >;
